<template>
  <div>
    <v-row>
      <v-col md="12" cols="12" class="ma-0 pa-0">
        <v-card>
          <v-card-text>
            <v-row>
              <v-col md="4">
                <h3 class="mt-2 mb-n8">
                  {{ input_date.format("dddd DD [de] MMMM [de] YYYY") }} -
                  {{ selectedTime }} a {{ selectedTime_end }}
                </h3>
                <br />
              </v-col>
              <v-col md="3">
                <div class="mx-2 mb-n8">
                  <v-autocomplete
                    dense
                    class="mb-n8"
                    outlined
                    label="Modalidad"
                    :items="tiposJuego"
                    item-value="id"
                    item-text="nombre"
                    @input="changeModalidad"
                    v-model="modalidad"
                  >
                  </v-autocomplete>
                </div>
              </v-col>
              <v-col md="5">
                <v-row>
                  <v-col v-if="!grupal" md="6" cols="12">
                    <v-text-field
                      class=""
                      outlined
                      dense
                      @keyup="changePlayersNumber()"
                      v-model="playersNumber"
                      label="Indica el numero de jugadores"
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="!grupal" md="6" cols="12">
                    <v-text-field
                      class=""
                      outlined
                      dense
                      v-model="Invitados"
                      label="Personas Extra"
                    ></v-text-field>
                  </v-col>

                  <v-col v-if="grupal" md="4" cols="12">
                    <v-text-field
                      class="mt-2"
                      outlined
                      dense
                      v-if="grupal"
                      @keyup="changePlayersNumber()"
                      v-model="playersNumber"
                      label="Indica el numero de jugadores"
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="grupal" md="4" cols="12">
                    <v-text-field
                      class="mt-2"
                      outlined
                      dense
                      v-if="grupal"
                      v-model="TTP"
                      label="Jugadores por tee Time"
                    ></v-text-field>
                  </v-col>
                  <v-col md="4">
                    <v-btn
                      class="mt-2"
                      v-if="grupal"
                      @click="grupal = false"
                      block
                      color="primary"
                      small
                      elevation="0"
                    >
                      Reserva ordinaria
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="12" cols="12">
        <v-tabs
          next-icon="mdi-arrow-right-bold-box-outline"
          prev-icon="mdi-arrow-left-bold-box-outline"
          show-arrows
          v-model="extraTabs"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab> Jugadores </v-tab>
          <v-tab> Notas </v-tab>
          <v-tab> Agencia</v-tab>
          <v-tab> Transportación </v-tab>
          <v-tab> Extra Riders </v-tab>
        </v-tabs>
        <v-tabs-items v-model="extraTabs">
          <v-tab-item class="pa-2">
            <v-tabs
              v-model="plyTabs"
              fixed-tabs
              dense
              background-color="indigo"
              dark
            >
              <v-tab> Nombres y Tarifas </v-tab>
              <v-tab> Extras </v-tab>
            </v-tabs>
            <v-tabs-items v-model="plyTabs">
              <v-tab-item class="pa-2">
                <v-form ref="playersForm">
                  <v-simple-table>
                    <thead>
                      <tr>
                        <th width="30%">Jugador</th>
                        <th width="20%">Tarifario</th>
                        <th width="20%">Tarifas</th>
                        <th width="10%">Precio</th>
                        <th width="10%">Opciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="(player, index) in players">
                        <tr :key="index">
                          <td class="pa-2">
                            <v-combobox
                              :label="'Jugador'"
                              class="mb-n6"
                              outlined
                              :search-input.sync="player.name"
                              dense
                              v-model="player.dataClient"
                              :items="comp_clients"
                              item-disabled="blqd"
                              item-value="Id"
                              @input="interceptorClient(player, index)"
                            >
                              <template v-slot:item="data">
                                <v-list-item-content
                                  v-bind:class="{
                                    accesoDenegado: data.item.blqd,
                                  }"
                                >
                                  {{ data.item.text }}<br />
                                  <b v-if="data.item.esMiembro"
                                    ><v-icon small color="yellow">
                                      mdi-star
                                    </v-icon>
                                    Miembro</b
                                  >
                                  <b v-if="data.item.blqd"
                                    ><v-icon small color="red">
                                      mdi-cancel
                                    </v-icon>
                                    Acceso denegado</b
                                  >
                                  <b v-if="data.item.blqd" class="mx-2 mb-2">{{
                                    data.item.nots
                                  }}</b>
                                  <v-chip color="primary" v-if="data.item.tipo">
                                    {{ data.item.tipo ? data.item.tipo : "" }}
                                  </v-chip>
                                </v-list-item-content>
                              </template>
                              <v-btn
                                small
                                @click="
                                  historyclient = player.dataClient;
                                  indexHistory++;
                                  showHistory = true;
                                "
                                elevation="0"
                                slot="append-outer"
                                outlined
                                dark
                                :color="$pgsHelper.uiConfig().mainColor"
                              >
                                <v-icon>mdi-account-clock</v-icon>
                              </v-btn>
                              <v-btn
                                small
                                elevation="0"
                                slot="append-outer"
                                @click="
                                  indexItem = index;
                                  idx.formClient++;
                                  showModalCliente = true;
                                "
                                dark
                                :color="$pgsHelper.uiConfig().mainColor"
                              >
                                <v-icon>mdi-account-plus</v-icon>
                              </v-btn>
                            </v-combobox>
                          </td>
                          <td class="pa-2">
                            <v-autocomplete
                              v-if="!player.useRondaCupon"
                              class="mb-n6"
                              :items="tarifaCombo"
                              outlined
                              dense
                              v-model="player.tarifario"
                              @input="getTarifasByTarifario(index)"
                              label="Seleccione un tarifario"
                            >
                            </v-autocomplete>
                          </td>
                          <td class="pa-2">
                            <h4 v-if="player.useRondaCupon">Ronda Prepagada</h4>
                            <v-autocomplete
                              v-if="!player.useRondaCupon"
                              class="mb-n6"
                              :items="player.listadoTarifas"
                              outlined
                              dense
                              v-model="player.tarifa"
                              @input="getTarifasByPlayer(index)"
                              :rules="Rules.Tarifa"
                              label="Seleccione una Tarifa"
                            >
                              <template v-slot:item="data">
                                <v-list-item-content>
                                  <v-list-item-title>
                                    {{ data.item.tarifarioName }}
                                    {{ data.item.text }}</v-list-item-title
                                  >
                                  <v-list-item-subtitle
                                    >{{ data.item.nombreHorario }} ${{
                                      data.item.Precio
                                    }}</v-list-item-subtitle
                                  >
                                  <v-list-item-subtitle
                                    >{{ data.item.temporadaName }} :
                                    {{
                                      $pgsHelper
                                        .getDate(data.item.Inicio)
                                        .format("DD/MM/YYYY")
                                    }}
                                    -
                                    {{
                                      $pgsHelper
                                        .getDate(data.item.Final)
                                        .format("DD/MM/YYYY")
                                    }}</v-list-item-subtitle
                                  >
                                </v-list-item-content>
                              </template>
                            </v-autocomplete>
                          </td>
                          <td class="pa-2">
                            <v-text-field
                              class="mb-n6"
                              v-if="player.TarifaSelected"
                              outlined
                              dense
                              @keypress="
                                $pgsHelper.onlyNumber($event, player.Precio)
                              "
                              v-model="player.Precio"
                              label="Precio"
                            >
                              <v-chip
                                slot="append-outer"
                                color="green"
                                dark
                                small
                                v-if="player.TarifaSelected"
                              >
                                {{ player.TarifaSelected.Moneda }}
                              </v-chip>
                            </v-text-field>
                            <v-chip
                              color="red"
                              dark
                              small
                              v-if="player.tarifa == ''"
                            >
                              Sin Precio
                            </v-chip>

                            <v-chip
                              color="red"
                              dark
                              small
                              v-if="
                                player.TarifaSelected == '' &&
                                player.tarifa != ''
                              "
                            >
                              Tarifa invalida
                            </v-chip>
                          </td>
                          <td>
                            <v-menu offset-y>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  color="primary"
                                  small
                                  dark
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  Opciones
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-item
                                  v-if="player.totalCupones > 0"
                                  @click="
                                    player.useRondaCupon =
                                      !player.useRondaCupon;
                                    setTarifaRodasSerie(
                                      player.useRondaCupon,
                                      index
                                    );
                                  "
                                >
                                  <v-list-item-title>
                                    <v-icon
                                      color="success"
                                      v-if="player.useRondaCupon"
                                      >mdi-check-circle</v-icon
                                    >
                                    Usar Ronda Prepago</v-list-item-title
                                  >
                                </v-list-item>
                                <v-list-item
                                  v-if="players.length > 1"
                                  @click="
                                    replicarJugador(
                                      player.tarifario,
                                      player.tarifa,
                                      player
                                    )
                                  "
                                >
                                  <v-list-item-title
                                    >Replicar Jugador</v-list-item-title
                                  >
                                </v-list-item>
                                <v-list-item
                                  v-if="players.length > 1"
                                  @click="
                                    replicarTarifa(
                                      player.tarifario,
                                      player.tarifa,
                                      player
                                    )
                                  "
                                >
                                  <v-list-item-title
                                    >Replicar Tarifa</v-list-item-title
                                  >
                                </v-list-item>

                                <v-list-item
                                  @click="player.useCupon = !player.useCupon"
                                >
                                  <v-list-item-title>
                                    <v-icon
                                      color="success"
                                      v-if="player.useCupon"
                                      >mdi-check-circle</v-icon
                                    >
                                    Cupón</v-list-item-title
                                  >
                                </v-list-item>
                                <v-list-item
                                  v-if="index != 0 && !editPlayers.edit"
                                  @click="deletePlayer(index)"
                                  class="red--text"
                                >
                                  <v-list-item-title>
                                    Eliminar</v-list-item-title
                                  >
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </v-simple-table>
                </v-form>
              </v-tab-item>
              <v-tab-item class="pa-2">
                <v-card
                  class="mx-2 my-2"
                  color="#e0e0e0"
                  elevation="0"
                  style=""
                >
                  <v-card-text>
                    <v-form ref="playersForm" class="my-2">
                      <template v-for="(player, index) in players">
                        <v-card
                          class="my-2"
                          :key="index"
                          v-show="
                            !editPlayers.edit || editPlayers.playerIdx == index
                          "
                        >
                          <div>
                            <v-card-text>
                              <v-row>
                                <v-col cols="12" md="12" class="mt-n2">
                                  <h4>
                                    Jugador {{ index + 1 }} -
                                    {{
                                      player.name == ""
                                        ? "Complete la información del jugador"
                                        : player.name
                                    }}
                                  </h4>
                                </v-col>
                                <v-col
                                  v-if="false"
                                  cols="12"
                                  md="12"
                                  class="mt-n4 mb-n3"
                                >
                                  <v-text-field
                                    @keypress="
                                      $pgsHelper.onlyNumber(
                                        $event,
                                        player.nCarrito
                                      )
                                    "
                                    v-model="player.nCarrito"
                                    label="Numero Carrito"
                                  ></v-text-field>
                                </v-col>

                                <v-col
                                  cols="12"
                                  md="12"
                                  v-if="player.esInvitado"
                                  class="mt-n2"
                                >
                                  <v-row class="mt-n6" v-if="player.esInvitado">
                                    <v-col md="12">
                                      <v-autocomplete
                                        v-model="player.IdMiembro"
                                        :items="comp_clients"
                                        item-value="Id"
                                        label="Invitado de:"
                                        @change="
                                          changeMiembroInvitado(player, index)
                                        "
                                      ></v-autocomplete>
                                      <v-alert
                                        v-if="
                                          !player.invitation.valid &
                                          (player.IdMiembro != '')
                                        "
                                        dense
                                        outlined
                                        type="error"
                                      >
                                        El miembro seleccionado no pude disponer
                                        de pases de invitado
                                      </v-alert>
                                      <v-alert
                                        v-if="
                                          player.invitation.valid &
                                          (player.IdMiembro != '')
                                        "
                                        dense
                                        outlined
                                        type="success"
                                      >
                                        Pase de invitado valido
                                      </v-alert>
                                    </v-col>
                                  </v-row>
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="12"
                                  v-if="player.golfClub"
                                  class="mt-n2"
                                >
                                  <v-row class="mt-n6">
                                    <v-col v-if="player.golfClub">
                                      <v-label>Gender:</v-label>
                                      <v-select
                                        v-model="player.genero"
                                        :items="['Man', 'Woman']"
                                        outlined
                                        dense
                                      ></v-select>
                                    </v-col>

                                    <v-col v-if="player.golfClub">
                                      <v-label>Hand:</v-label>
                                      <v-select
                                        v-model="player.side"
                                        :items="
                                          player.genero === 'Man'
                                            ? ['left', 'right']
                                            : ['right']
                                        "
                                        outlined
                                        dense
                                      ></v-select>
                                    </v-col>

                                    <v-col
                                      v-if="
                                        player.golfClub &&
                                        player.genero === 'Man'
                                      "
                                      class="field"
                                    >
                                      <v-label>Shaft:</v-label>
                                      <v-select
                                        v-model="player.shaft"
                                        :items="['regular', 'stiff']"
                                        outlined
                                        dense
                                      ></v-select>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </div>
                        </v-card>
                      </template>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tab-item>
          <v-tab-item class="pa-2">
            <v-textarea label="Notas de la reserva" v-model="nota"></v-textarea>
          </v-tab-item>
          <v-tab-item class="pa-2">
            <h5>Seleccione una Agencia (Opcional)</h5>
            <v-autocomplete
              :items="mayoristas.mayoristas"
              v-model="Mayorista.Id"
              @input="onChangeMayorista()"
              label="Agencia"
              item-text="Nombre"
              item-value="id"
            ></v-autocomplete>
            <h5>Seleccione un Concierge (Opcional)</h5>
            <v-autocomplete
              :items="concierges"
              v-model="Concierge.Id"
              @input="onChangeConcierge()"
              label="Concierge"
              item-text="nom"
              item-value="id"
            ></v-autocomplete>
          </v-tab-item>
          <v-tab-item class="pa-2">
            <TransportacionForm
              :key="tranindx"
              :paxNumber="this.players.length + this.cartRiders.length"
              :prefered="this.isPreferedTime"
              :fecha="this.input_date.format('YYYY-MM-DD')"
              :time="this.selectedTime"
              @onChangeTransportationData="setTransData"
            />
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col md="8">
                <v-text-field
                  v-model="cartRiderName"
                  label="Nombre"
                ></v-text-field>
              </v-col>
              <v-col v-if="Addons.cartRider" md="4">
                <v-btn outlined color="green" @click="addCartRider" block
                  >Add + {{ Addons.cartRider.Precio }}
                  {{ Addons.cartRider.Moneda }}
                </v-btn>
              </v-col>
              <v-col md="12">
                <v-list dense>
                  <template v-for="(cartRider, index) in cartRiders">
                    <v-list-item :key="index">
                      <v-list-item-content>
                        <h3>Nombre: {{ cartRider.Nombre }}</h3>
                        <v-row>
                          <v-col>
                            <v-text-field
                              v-model="cartRider.Pco.C"
                              label="Precio"
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col>
                            <v-select
                              v-model="cartRider.Pco.M"
                              label="Moneda"
                              :items="getPDVMonedasLista"
                              item-value="id"
                              item-text="Nombre"
                              dense
                            >
                            </v-select>
                          </v-col>
                        </v-row>
                      </v-list-item-content>
                      <a
                        style="float: right"
                        @click="deleteCartRider(index)"
                        href="javascript:void(0);"
                        class="aligned"
                        ><i class="large close middle aligned icon"></i>
                      </a>
                    </v-list-item>
                  </template>
                </v-list>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-col>

      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="12"
        xl="12"
        style="height: calc(100vh - 160px)"
      >
        <div
          style="
            position: fixed !important;
            bottom: 0 !important;
            width: 100% !important;
          "
        >
          <v-card style="height: 150px" elevation="0">
            <v-card-text>
              <v-alert style="" icon="mdi-currency-usd" type="info" text>
                <h5>
                  Total USD:${{
                    $pgsHelper.formatNumber(grandTotal.total)
                  }}
                  Total MXN:${{
                    $pgsHelper.formatNumber(grandTotal.totalPesos)
                  }}
                </h5>
              </v-alert>
              <v-btn
                style="width: inherit"
                @click="buildReservationData()"
                x-large
                block
                :loading="loadindAction"
                v-if="loadingData == false"
                color="success"
              >
                Reservar
              </v-btn>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
    </v-row>

    <!--<div class="big ui right aligned primary button full-button" @click="$router.push({path:'/proshop/menu'})" style="float: right; margin-top: 10px;"><i class="reply icon" ></i>Regresar </div>-->

    <modal v-model="confirmBook" :showFooter="false" title="Reserva Guardada">
      <p>La reserva se guardo correctamente, ¿Cómo deseas continuar?</p>
      <div>
        <v-btn
          @click="$router.push({ path: '/proshop/sales-point' })"
          color="green"
        >
          Ir a Punto de Venta
        </v-btn>

        <v-btn
          @click="confirmBook = false"
          color="secondary"
        >
          Nueva Reserva
        </v-btn>

        <v-btn
          @click="$router.push({ path: '/proshop/menu' })"
          color="primary"
        >
          Ir a Menu
        </v-btn>
      </div>
    </modal>

    <modal
      v-model="showModalCliente"
      :showFooter="false"
      title="Agregar Cliente"
    >
      <FormClientes
        :edit="false"
        :key="idx.formClient"
        @toggle="showModalCliente = false"
        :dataEdit="{}"
      ></FormClientes>
    </modal>
    <v-dialog v-model="showModalEvaliv" persistent max-width="500">
      <EvalivInterceptor
        :cliente="clienteEvaliv"
        :edit="false"
        :key="evalivIndex"
        :indexItem="indexPlayerEvaliv"
        @rechazarCliente="rechazarCliente"
        @aceptarCliente="aceptarCliente"
        @toggle="showModalEvaliv = false"
        :dataEdit="{}"
      ></EvalivInterceptor>
    </v-dialog>
    <v-dialog v-model="showHistory" persistent max-width="800">
      <PlayerHistoriCard
        @close="showHistory = false"
        :key="indexHistory"
        :player="historyclient"
      ></PlayerHistoriCard>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
//import Select2 from "v-select2-component";
import modal from "../../MainComponents/modal.vue";
import EvalivInterceptor from "../EvalivInterceptor.vue";
import MembresiaClass from "../../../clases/Membresias/Membresia.js";
import FormClientes from "../../Clientes/Clientes/ClienteForm.vue";
import TransportacionForm from "../TransportacionForm.vue";
import PlayerHistoriCard from "../PlayerHistoriCard.vue";
import TarifasClass from "../../../clases/Tarifa.js";
import Cliente from "../../../clases/Cliente.js";
import ReservaClass from "../../../clases/Reserva.js";
import { UID } from "../../../clases/UID.js";
export default {
  name: "BookingForm",
  components: {
    FormClientes,
    modal,
    TransportacionForm,
    EvalivInterceptor,
    PlayerHistoriCard,
  },
  props: [
    "selectedT",
    "editMode",
    "loadindAction",
    "editData",
    "Concierges",
    "grupos",
    "dpto",
    "rvaDepto",
    "dataTimes",
    "maxPlayers",
  ],
  data() {
    return {
      Invitados: 0,
      selectedTimeEnd: "",
      indexHistory: 0,
      showHistory: false,
      historyclient: null,
      TTP: 4,
      extraTabs: 0,
      ConfigRva: null,
      Rules: ReservaClass.getRules(),
      grupal: false,
      plyTabs: 0,
      idx: {
        formClient: 0,
      },
      Id: "",
      doAction: "",
      input_date: new moment(),
      MainDepartamento: "Golf",
      selectedTime: "",
      allowPlayers: 0,
      playersNumber: 1,
      modalidad: "",
      checkAsGuest: false,
      players: [
        {
          isAdeudo: false,
          listadoTarifas: [],
          tarifario: "",
          totalCupones: 0,
          useRondaCupon: false,
          dataClient: "",
          cuponSelected: "",
          combo_cupon: [],
          formMayorista: "",
          useCupon: false,
          esInvitado: false,
          IdMiembro: "",
          invitation: { valid: false },
          name: "",
          email: "",
          phone: "",
          golfClub: false,
          side: "right",
          genero: "Man",
          shaft: "regular",
          tarifa: "",
          isClient: false,
          TarifaSelected: "",
          IdCliente: " ",
          hdcp: "",
          Precio: 0,
          nCarrito: "",
        },
      ],
      editPlayers: {
        edit: false,
        playerIdx: "",
      },
      nota: "",
      temporadas: [],
      tarifaCombo: [],
      tiposJuego: [],
      subcategorias: [],
      gruposCliente: [],
      Horarios: [],
      cartRiders: [],
      confirmBook: false,
      transModal: false,
      Transportacion: null,
      Mayorista: {
        Id: null,
        Nm: "",
      },
      Concierge: {
        Id: null,
        Nm: "",
      },
      showModalCliente: false,
      modalOpen: false,
      isAdmin: false,
      transportation: false,
      loadingData: false,
      private_reservation: false,
      Session: "",
      ApiToken: "",
      TotalTrans: 0,
      RowId: "",
      DuracionViaje: "",
      rawDuracionViaje: "",
      HtlPickup: "",
      PCGCPickup: "",
      guessConfig: {},
      tranindx: 1,
      isPreferedTime: false,
      cartRiderName: "",
      clienteEvaliv: null,
      showModalEvaliv: false,
      evalivIndex: 0,
      indexPlayerEvaliv: 0,
      clientAdd: {
        nombre: "",
        apellidos: "",
        correo: "",
        telefono: "",
        grupo: "",
        tipoMembresia: "",
      },
      errors: {
        time: false,
        players: false,
        code: false,
      },
    };
  },
  methods: {
    getGrupoInfo(id) {
      let grupo = this.$pgsHelper.getById(this.grupos, "value", id);
      return grupo.text;
    },
    changeModalidad() {
      this.players.forEach(async (player, index) => {
        await this.getTarifasByTarifario(index);
        await this.getTarifasByPlayer(index);
      });
    },
    interceptorClient(player, index) {
      let tenant = this.$store.getters.getFirebaseApp.tenant;

      if (tenant === "PCUN") {
        //this.setPlayerData(player, index)
        if (player?.dataClient?.Id) {
          this.clienteEvaliv = this.$pgsHelper.cloneObj(player);

          this.indexPlayerEvaliv = index;
          this.evalivIndex++;
          this.showModalEvaliv = true;
        } else {
          this.setPlayerData(player, index);
        }
      } else {
        this.setPlayerData(player, index);
      }
    },
    rechazarCliente(data) {
      this.players[data.index].isClient = false;
      this.players[data.index].name = "";
      this.players[data.index].dataClient = "";

      this.showModalEvaliv = false;
    },
    aceptarCliente(data) {
      this.players[data.index].dataClient = this.clienteEvaliv.dataClient;
      this.players[data.index].isAdeudo = data.isAdeudo;
      this.players[data.index].esInvitado = false;

      this.setPlayerData(this.players[data.index], data.index);
      this.showModalEvaliv = false;
    },
    onChangeMayorista() {
      let mayorista = this.$pgsHelper.getById(
        this.mayoristas.mayoristas,
        "Id",
        this.Mayorista.Id
      );
      if (mayorista) {
        this.Mayorista.Nm = mayorista.Nombre;
      }
    },
    onChangeConcierge() {
      if (this.Concierge) {
        let mayorista = this.$pgsHelper.getById(
          this.concierges,
          "id",
          this.Concierge.Id
        );

        if (mayorista) {
          this.Concierge.Nm = mayorista.nom;
        }
      }
    },
    init() {
      this.getTiposJuego()
        .then(() => {
          return this.getTemporadas();
        })
        .then(async () => {
          await this.getHorarios();
          await this.getSubcategoria();
          await this.getTarifarios();
        });
    },
    async replicarTarifa(tarifario, tarifa, player) {
      if (tarifa != "") {
        this.players.forEach(async (element, index) => {
          if (index != 0) {
            element.tarifario = tarifario;
            await this.getTarifasByTarifario(index);
            element.tarifa = tarifa;
            this.getTarifasByPlayer(index);
          }
        });
      }
    },
    async replicarJugador(tarifario, tarifa, player) {
      this.players.forEach(async (element, index) => {
        if (index != 0) {
          element.isClient = player.isClient;
          element.dataClient = player.dataClient;
          element.IdCliente = player.IdCliente;
          element.name = player.name;
          element.isAdeudo = player.isAdeudo;
        }
      });
    },
    async getHorarios() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "RVA/Tarifas/" + this.rvaDepto + "/Horarios"
        );

      if (!data.exists()) {
        return false;
      }
      let arrayHorarios = Object.entries(data.val());
      var $this = this;
      arrayHorarios.forEach(function (element) {
        $this.Horarios.push({ id: element[0], ...element[1] });
      });
    },
    async getSubcategoria() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "RVA/Tarifas/" + this.rvaDepto + "/SubCategorias"
        );
      if (!data.exists()) {
        return false;
      }
      let arrayHoteles = Object.entries(data.val());

      arrayHoteles.forEach((element) => {
        this.subcategorias.push({
          id: element[0],
          key: element[0],
          text: element[1].Nombre,
          value: element[0],
          ...element[1],
        });
      });
    },
    deletePlayer(index) {
      this.players.splice(index, 1);
      this.playersNumber = this.players.length;
      this.forceRecomputeCounter++;
    },
    async getTiposJuego() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "RVA/Tarifas/" + this.rvaDepto + "/Modalidades"
        );
      let arrayTipos = Object.entries(data.val());
      var $this = this;
      arrayTipos.forEach((element) => {
        $this.tiposJuego.push({
          id: element[0],
          codigo: element[1]["Codigo"],
          nombre: element[1]["Nombre"],
        });
        //if (element[1]["Codigo"] == "18HOLES") {
        this.modalidad = element[0];
        //}
      });
      let tenant = this.$store.getters.getFirebaseApp.tenant;
      let juegoDefault = this.$pgsHelper.getById(
        this.tiposJuego,
        "codigo",
        "1HOR30M"
      );
      if (juegoDefault && tenant == "PCUN") {
        this.modalidad = juegoDefault.id;
      }
    },
    async getTemporadas() {
      /*
         Obtiene las temporadas existentes en la db
        */
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "RVA/Tarifas/" + this.rvaDepto + "/Temporadas"
        );
      if (!data.exists()) {
        return false;
      }
      let arrayTarifas = Object.entries(data.val());
      arrayTarifas.forEach((element) => {
        if (element[1].Activo) {
          this.temporadas.push({ id: element[0], ...element[1] });
        }
      });
    },
    changePlayersNumber() {
      //this.players= [{name:'',email:'',phone:'',golfClub:false,side:"right",genero:'Man',shaft:'regular'}];
      if (this.players.length < this.playersNumber) {
        var i;
        for (i = this.players.length; i < this.playersNumber; i++) {
          this.players.push({
            isAdeudo: false,
            listadoTarifas: [],
            tarifario: "",
            totalCupones: 0,
            useRondaCupon: false,
            dataClient: "",
            cuponSelected: "",
            combo_cupon: [],
            formMayorista: "",
            useCupon: false,
            esInvitado: false,
            IdMiembro: "",
            invitation: { valid: false },
            name: "",
            email: "",
            phone: "",
            golfClub: false,
            side: "right",
            genero: "Man",
            shaft: "regular",
            tarifa: "",
            isClient: false,
            TarifaSelected: "",
            IdCliente: " ",
            hdcp: "",
            Precio: 0,
            nCarrito: "",
          });
        }
      } else if (this.players.length > this.playersNumber) {
        for (i = this.playersNumber; i < this.players.length; i) {
          this.players.pop();
        }
      }
    },
    editPlayer(index) {
      this.editPlayers.edit = !this.editPlayers.edit;
      this.editPlayers.playerIdx = index;
    },
    async setPlayerData(player, index) {
      try {
        if (player.dataClient.Id) {
          player.isClient = true;

          player.IdCliente = player.dataClient.Id;
          player.name =
            player.dataClient.Apellidos + " " + player.dataClient.Nombres;
          player.email = player.dataClient.Correo;

          let dataCupones = [];
          let totalCupones = 0;
          if (player.dataClient.Cupones) {
            player.dataClient.Cupones.sort(function (a, b) {
              // Turn your strings into dates, and then subtract them
              // to get a value that is either negative, positive, or zero.
              return new Date(b.Exp.FT) - new Date(a.Exp.FT);
            });
            let arrayCupones = player.dataClient.Cupones.filter((cpn) => {
              return cpn.Cupon.Subtipo === "Rondas" && cpn.Exp.ES === "A";
            });
            arrayCupones.forEach((serie) => {
              for (let index = 0; index < serie.Con.Disponibles; index++) {
                totalCupones++;
                serie.Cupon.CCI = serie._CCI;
                dataCupones.push(serie.Cupon);
              }
            });
            player.dataClient.Cupones.forEach((serie) => {
              for (let index = 0; index < serie.Con.Disponibles; index++) {
                totalCupones++;
                serie.Cupon.CCI = serie._CCI;
                dataCupones.push(serie.Cupon);
              }
            });
          }
          if (totalCupones >= 0) {
            player.useRondaCupon = false;
            player.Tarifas = "";
            player.TarifaSelected = "";
            player.Precio = 0;
            this.getTarifasByPlayer(index);
          }
          player.totalCupones = totalCupones;
          player.dataClient.dataCupones = dataCupones;
          // player.dataClient = player.IdCliente;
          player.dataCupones = dataCupones;
          player.paseSocio = null;
          player.PlanMemebresia = null;
          if (player.dataClient.ExtraData) {
            if (player.dataClient.ExtraData.Membresia) {
              if (player.dataClient.ExtraData.Membresia.Membresia) {
                let membresiaCliente = await MembresiaClass.getById(
                  player.dataClient.ExtraData.Membresia.Membresia
                );
                if (membresiaCliente) {
                  let planMembresia = await membresiaCliente.getPlan();
                  let beneficios = await planMembresia.getBeneficios();
                  player.PlanMemebresia = planMembresia.Id;
                  beneficios.Beneficios.forEach(async (beneficio) => {
                    if ((beneficio.Tipo == "RVA") & !beneficio.EsInvitado) {
                      if (beneficio.Departamento == this.rvaDepto) {
                        //valida si el beneficio es ilimitado y si no si aun puede usarse
                        if (beneficio.Cantidad) {
                          let contador =
                            membresiaCliente.getContadoresByClientIndex(
                              membresiaCliente.Clientes[player.IdCliente]
                            )
                              ? membresiaCliente.getContadoresByClientIndex(
                                  membresiaCliente.Clientes[player.IdCliente]
                                )[beneficio.IDX].U
                              : 0;
                          if (beneficio.Cantidad <= contador) {
                            player.paseSocio = null;
                            return false;
                          }
                        }
                        //si el beneficio es valido, setea la tarifa que indica el beneficio
                        player.tarifario = beneficio.Tarifario;
                        player.paseSocio = beneficio;
                        player.paseSocio.Membresia =
                          player.dataClient.ExtraData.Membresia.Membresia;
                        player.paseSocio.Plan = planMembresia.Id;
                        player.paseSocio.Miembro = player.IdCliente;
                        await this.getTarifasByTarifario(index);
                        let tarifa = "";
                        player.listadoTarifas.forEach((tar) => {
                          if (
                            tar.data.Subcategoria[0] == beneficio.SubCategoria
                          ) {
                            tarifa = tar;
                          }
                        });
                        if (tarifa != "") {
                          player.tarifa = tarifa.value;
                          await this.getTarifasByPlayer(index);
                        }
                      }
                    }
                  });
                }
              }
            }
          }
        } else {
          player.isClient = false;
          player.PlanMemebresia = null;
          player.name = player.dataClient;
        }
        await this.getTarifasByTarifario(index);
      } catch (e) {
        console.log(e);
      }
    },
    async changeMiembroInvitado(player, index) {
      let cliente = this.$pgsHelper.getById(
        this.data_clientes,
        "Id",
        player.IdMiembro
      );
      player.invitation.valid = false;
      if (cliente.ExtraData) {
        if (cliente.ExtraData.Membresia) {
          if (cliente.ExtraData.Membresia.Membresia) {
            let membresiaCliente = await MembresiaClass.getById(
              cliente.ExtraData.Membresia.Membresia
            );
            if (membresiaCliente) {
              let planMembresia = await membresiaCliente.getPlan();
              let beneficios = await planMembresia.getBeneficios();
              beneficios.Beneficios.forEach(async (beneficio) => {
                if ((beneficio.Tipo == "RVA") & beneficio.EsInvitado) {
                  if (beneficio.Departamento == this.rvaDepto) {
                    //valida si el beneficio es ilimitado y si no si aun puede usarse
                    if (beneficio.Cantidad) {
                      let contadores =
                        await membresiaCliente.getContadoresByClientIndex(
                          membresiaCliente.Clientes[player.IdMiembro]
                        );
                      let contador = contadores[beneficio.IDX]
                        ? contadores[beneficio.IDX].U
                        : 0;
                      if (beneficio.Cantidad <= contador) {
                        player.invitation.valid = false;
                        this.$swal(
                          "El miembro seleccionado utilizo el total del beneficio"
                        );
                        return false;
                      }
                    }
                    //si el beneficio es valido, setea la tarifa que indica el beneficio
                    player.tarifario = beneficio.Tarifario;
                    await this.getTarifasByTarifario(index);
                    let tarifa = "";
                    player.listadoTarifas.forEach((tar) => {
                      if (tar.data.Subcategoria[0] == beneficio.SubCategoria) {
                        tarifa = tar;
                      }
                    });
                    if (tarifa != "") {
                      player.tarifa = tarifa.value;
                      await this.getTarifasByPlayer(index);
                      player.invitation.valid = true;
                      player.invitation.miembro = player.IdMiembro;
                      player.invitation.beneficio = beneficio.IDX;
                      player.invitation.membresia =
                        cliente.ExtraData.Membresia.Membresia;
                      player.invitation.plan = planMembresia.Id;
                    }
                  }
                }
              });
            }
          }
        }
      }
    },
    async getTarifarios() {
      if (!this.rvaDepto) {
        this.getTarifasCombo();
        return false;
      }

      let tarifarios = await TarifasClass.getMixTarifasCombo(this.rvaDepto);
      tarifarios.forEach((element) => {
        element.value = element.Id;
        element.text = element.Nombre;
      });
      this.tarifaCombo = tarifarios;
    },
    async getTarifasByTarifario(indexPly) {
      let idTemporada = "";
      let temporadasAplicables = [];
      this.temporadas.forEach((element) => {
        if (
          moment(element.FechaInicio).format("YYYY-MM-DD") <=
            this.input_date.format("YYYY-MM-DD") &&
          moment(element.FechaTermino).format("YYYY-MM-DD") >=
            this.input_date.format("YYYY-MM-DD")
        ) {
          temporadasAplicables.push(element.id);
          idTemporada = element.id;
        }
      });
      let TarifasCombo = [];
      let TarifasList = []; // new method
      let taskTarifas = temporadasAplicables.map(async (id) => {
        let tarifas = await TarifasClass.getMixTarifasByTarifarioParse(
          this.players[indexPly].tarifario,
          id,
          this.rvaDepto,
          this.Horarios,
          this.temporadas,
          this.tiposJuego,
          this.input_date.day()
        );
        tarifas.forEach((tar) => {
          TarifasList.push(tar);
        });
      });
      await Promise.all(taskTarifas).then(() => {
        TarifasList.forEach((tarifa, index) => {
          let nameTarifa = "Tarifa: ";
          let categoriaId = null;
          let categoriaName = null;
          tarifa.Subcategoria.forEach((element) => {
            categoriaId = element;
            nameTarifa +=
              this.$pgsHelper.getById(this.subcategorias, "id", element)
                .Nombre + " ";
            categoriaName = this.$pgsHelper.getById(
              this.subcategorias,
              "id",
              element
            ).Nombre;
          });
          let nombreHorario = "";
          let Precio = 0;
          let PrecioCon = 0;
          if (tarifa.arrayPrecios) {
            tarifa.arrayPrecios.forEach((modalidad) => {
              if (modalidad.id == this.modalidad) {
                modalidad.horarios.forEach((horario) => {
                  if (
                    moment(horario.data.HoraTermino, "HH:mm:ss").format(
                      "HH:mm"
                    ) >= moment(this.selectedTime, "HH:mm").format("HH:mm") &&
                    moment(horario.data.HoraInicio, "HH:mm:ss").format(
                      "HH:mm"
                    ) <= moment(this.selectedTime, "HH:mm").format("HH:mm")
                  ) {
                    nombreHorario = horario.data.Nombre;
                    (Precio = horario.PcoVen + " " + horario.Moneda),
                      (PrecioCon = horario.PcoCon + " " + horario.Moneda),
                      /*this.players[index].TarifaSelected = {
                      Tarifa: tarifa,
                      Nombre: tarifa.text,
                      TarifaId: tarifa.value,
                      Horario: horario,
                      horarioNombre: horario.data.Nombre,
                      tarifarioNombre: tarifarioData.Nombre,
                      Precio: horario.PcoVen,
                      PrecioCon: horario.PcoCon,
                      Moneda: horario.Moneda,
                    };*/

                      this.$forceUpdate();
                  }
                });
              }
            });
          }
          let tarifaValida = true;
          if (!tarifa.SoloPlanes) {
            tarifaValida = true;
          } else {
            if (this.players[indexPly].PlanMemebresia) {
              if (
                tarifa.SoloPlanes.includes(
                  this.players[indexPly].PlanMemebresia
                )
              ) {
                tarifaValida = true;
              } else {
                tarifaValida = false;
              }
            } else {
              tarifaValida = false;
            }
          }
          if (tarifaValida) {
            TarifasCombo.push({
              value: tarifa.id,
              text: nameTarifa,
              data: tarifa,
              nombreHorario: nombreHorario,
              Turista: tarifa.Turista || false,
              Iid: tarifa.Iid || null,
              Color: tarifa.Color || null,
              Precio: Precio,
              PrecioCon: PrecioCon,
              tarifarioName: this.$pgsHelper.getById(
                this.tarifaCombo,
                "value",
                tarifa.Tarifario
              ).text,
              Inicio: this.$pgsHelper.getById(
                this.temporadas,
                "id",
                tarifa.Temporada
              ).FechaInicio,
              Final: this.$pgsHelper.getById(
                this.temporadas,
                "id",
                tarifa.Temporada
              ).FechaTermino,
              temporadaName: this.$pgsHelper.getById(
                this.temporadas,
                "id",
                tarifa.Temporada
              ).Nombre,
              cateTarifa: {
                id: categoriaId,
                nombre: categoriaName,
              },
            });
          }
          if (this.players[indexPly].TarifaSelected) {
            if (this.players[indexPly].TarifaSelected?.TarifaId == tarifa.id) {
              if (!tarifaValida) {
                this.players[indexPly].TarifaSelected = "";
              }
            }
          }
        });
        this.players[indexPly].listadoTarifas = TarifasCombo;
      });
    },
    async getTarifasByPlayer(index) {
      let idTemporada = 0;
      let idTarifa = this.players[index].tarifa;

      let tarifa = this.$pgsHelper.getById(
        this.players[index].listadoTarifas,
        "value",
        idTarifa
      );
      let tarifarioData = this.$pgsHelper.getById(
        this.tarifaCombo,
        "value",
        this.players[index].tarifario
      );
      //this.players[index].Tarifas = "";
      this.players[index].TarifaSelected = "";
      this.players[index].Precio = "";
      if (tarifa.data) {
        tarifa.data.arrayPrecios.forEach((modalidad) => {
          if (modalidad.id == this.modalidad) {
            if (modalidad.horarios.length == 0) {
              //this.players[index].Tarifas = "";
              this.players[index].TarifaSelected = "";
              this.players[index].Precio = 0;
            }
            modalidad.horarios.forEach((horario) => {
              if (
                moment(horario.data.HoraTermino, "HH:mm:ss").format("HH:mm") >=
                  moment(this.selectedTime, "HH:mm").format("HH:mm") &&
                moment(horario.data.HoraInicio, "HH:mm:ss").format("HH:mm") <=
                  moment(this.selectedTime, "HH:mm").format("HH:mm")
              ) {
                this.players[index].TarifaSelected = {
                  Tarifa: tarifa,
                  Nombre: tarifa.text,
                  Turista: tarifa.Turista,
                  Iid: tarifa.Iid,
                  TarifaId: tarifa.value,
                  Color: tarifa.Color,
                  Horario: horario,
                  horarioNombre: horario.data.Nombre,
                  tarifarioNombre: tarifarioData.Nombre,
                  Precio: horario.PcoVen,
                  PrecioCon: horario.PcoCon,
                  Moneda: horario.Moneda,
                };
                this.players[index].Precio = horario.PcoVen;
                this.$forceUpdate();
              }
            });
          }
        });
      }

      this.$forceUpdate();
      this.forceRecomputeCounter++;
    },
    changeAsGuest() {
      var $this = this;
      if (this.checkAsGuest == true) {
        var pNumber = 1;
        $this.players.forEach(async function (element, index) {
          if (index != 0 && element.name == "") {
            element.name = "Guest " + pNumber;
            element.email = "guest@guestmail.com";
            pNumber++;
            if ($this.guessConfig) {
              element.tarifario = $this.guessConfig.tarifario;
              element.tarifario = $this.guessConfig.tarifario;
              await $this.getTarifasByTarifario(index);
              let tarifa = "";
              element.listadoTarifas.forEach((tar) => {
                if (tar.data.Subcategoria[0] == $this.guessConfig.categoria) {
                  tarifa = tar;
                }
              });
              if (tarifa != "") {
                element.tarifa = tarifa.value;
                $this.getTarifasByPlayer(index);
              }
            }
          }
        });
      } else {
        $this.players.forEach(function (element, index) {
          if (index != 0) {
            element.name = "";
            element.email = "";
          }
        });
      }
    },
    async setTarifaRodasSerie(use, index) {
      if (use) {
        this.players[index].TarifaSelected = {
          Accesos: ["Global"],
          Nombre: "Ronda Prepagada",
          TarifaId: "rondaCupon",
          Precio: 0,
          horarioNombre: "",
          Moneda: "USD",
        };
        this.players[index].tarifa = "rondaCupon";
        this.players[index].useCupon = false;
        this.players[index].Precio = 0;
      } else {
        this.players[index].Tarifas = "";
        this.players[index].TarifaSelected = "";
        this.players[index].Precio = 0;
      }

      //tarifas_array.push(tarifa_global);
    },
    setTransData(data) {
      if (data.useTransportacion) {
        this.Transportacion = data.dataForm;
      } else {
        this.Transportacion = null;
      }
    },
    async getUserGroups() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/GruposCliente"
        );
      let arrayGrupos = Object.entries(data.val());

      let grupos = [];
      arrayGrupos.forEach(function (element) {
        grupos.push({ value: element[0], text: element[1]["Nombre"] });
      });
      this.gruposCliente = grupos;
    },
    addCartRider() {
      if (this.cartRiderName !== "") {
        this.cartRiders.push({
          Nombre: this.cartRiderName,
          Pco: {
            C: this.Addons.cartRider.Precio,
            M: this.Addons.cartRider.Moneda,
          },
          UID: UID.getUID(),
        });
        this.cartRiderName = "";
        /*if(this.transportation){
               // this.getTransportationData();
            }*/
      } else {
        this.$swal({
          icon: "error",
          title: "Cart Rider Name is required",
          text: "",
        });
      }
    },
    deleteCartRider(index) {
      this.cartRiders.splice(index, 1);
      //this.getTransportationData();
    },
    toggleModal() {
      this.modalOpen = !this.modalOpen;
    },
    validateClientForm() {
      let valid = true;
      if (this.clientAdd.nombre == "") {
        valid = false;
      }

      if (this.clientAdd.apellidos == "") {
        valid = false;
      }

      if (this.clientAdd.email == "") {
        valid = false;
      }

      return valid;
    },
    changeTrans(value) {
      //this.transportation = value;
      if (value == true) {
        this.transModal = true;
      } else {
        /*if(this.selectedPriceIndex === ""){
                this.$swal(
                    'Selecciona un horario',
                    'Selecciona un horario de juego antes de solicitar transportacion ',
                    'error'
                )

                document.getElementsByName('trans').forEach((element =>{
                    element.checked = false;
                }))
        }else if(this.transportation && this.selectedPriceIndex !== ""){
            if(this.isHotel){
                this.getTransportationData();
            }
            
        }*/
        this.Session = "";
        this.ApiToken = "";
        this.TotalTrans = 0;
        this.RowId = "";
        this.RsvaId = "";
        this.DuracionViaje = "";
        this.HtlPickup = "";
        this.PCGCPickup = "";
        //this.Confirm ="";
        this.transportation = value;
        this.tranindx++;
        this.$swal(
          "No se transportara a los jugadores",
          "La transportacion al campo de golf  no sera incluida en esta reserva ",
          "error"
        );
      }
    },
    buildReservationData() {
      var valid = true;
      if (this.$refs.playersForm.validate()) {
        console.log("valido");
      }
      let aux = 0;
      let playersError = "";
      this.players.forEach((element, index) => {
        playersError = playersError + "Jugador " + (index + 1) + " ";
        if (element.name == "" || element.tarifa == "") {
          aux++;
        }
      });

      if (aux > 0) {
        valid = false;
        this.errors.players = true;
      } else {
        this.errors.players = false;
      }

      this.$pgsHelper.log(this.transportation);
      if (this.transportation === "") {
        valid = false;
        this.errors.trans = true;
      } else {
        this.errors.trans = false;
      }

      if (!valid) {
        this.$swal(
          "Complete la información de los jugadores correctamente",
          "Verifique el nombre y la tarifa de: " + playersError,
          "error"
        );
        return false;
      }

      let resData = ReservaClass.buildRVAData({
        Tipo: this.rvaDepto,
        Cliente: this.players[0],
        Players: this.players,
        Estatus: "Confirmed",
        Familia: this.ConfigRva?.Contabilidad?.Familia,
        Privado: false,
        TTP: this.grupal ? this.TTP : 4,
        FechaInicial:
          this.input_date.format("YYYY-MM-DD") +
          "_" +
          moment(this.selectedTime, "HH:mm").format("HH:mm:ss"),
        FechaFinal:
          this.input_date_end.format("YYYY-MM-DD") +
          "_" +
          moment(this.selectedTime_end, "HH:mm").format("HH:mm:ss"),
        Total: this.grandTotal,
        Prepagado: false,
        Notas: this.nota,
        Bahia: this.selectedT[0].bay,
        TimesData: this.dataTimes,
        Invitados: Number(this.Invitados),
        Departamento: this.rvaDepto,
        Tags: [this.rvaDepto],
        Creador: this.isWeb ? "Web" : "ProShop",
        Modalidad: this.$pgsHelper.getById(
          this.tiposJuego,
          "id",
          this.modalidad
        ),
        Mayorista: this.Mayorista.Id ? this.Mayorista : null,
        Concierge: this.Concierge.Id ? this.Concierge : null,
        Transportacion: this.Transportacion,
        CartRiders: this.cartRiders,
        Addons: this.Addons,
      });
      resData.grupal = this.grupal;

      let doAction = "CREATE";
      this.$emit("successData", resData, doAction);
    },
    async getConfig() {
      const conf =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "RVA/Configuracion/" + localStorage.getItem("selectedDepartment") + ""
        );
      let resultConf = conf.val();
      this.ConfigRva = resultConf;
      this.guessConfig = resultConf?.GUEST;
    },
  },
  computed: {
    ...mapGetters(["getPDVMonedasLista"]),
    tiposCambio() {
      let cambio = this.$store.getters.getTiposCambios;
      return cambio[0];
    },
    mayoristas() {
      let mayoristas = this.$store.getters.getMayoristas;
      let mayoristasComp = [{ id: null, Nombre: "Sin Agencia" }];
      mayoristas.forEach((element) => {
        mayoristasComp.push({
          value: element.id,
          text: element.Nombre,
          ...element,
        });
      });

      return { mayoristas: mayoristasComp, mayoristasSearch: mayoristasComp };
    },
    concierges() {
      let concierges = this.Concierges;
      let conciergeComp = [{ id: null, nom: "Sin Concierge" }];
      concierges.forEach((element) => {
        if (!element.dlat) {
          if (this.Mayorista.Id) {
            if (element.htl.id == this.Mayorista.Id) {
              conciergeComp.push({
                value: element.id,
                text: element.nm,
                ...element,
              });
            }
          } else {
            conciergeComp.push({
              value: element.id,
              text: element.nm,
              ...element,
            });
          }
        }
      });

      return conciergeComp;
    },
    Addons() {
      /*
        Obtiene las temporadas existentes en la db
        */
      let AddOn = {};
      let addons = this.$store.getters.getRVACatalogo;
      AddOn.cartRider = addons.GOLFRIDDER;
      AddOn.golfClub = addons.GOLFCLUB;
      AddOn.transport = addons.TRANSPORT;
      AddOn.roundGolf = addons.GOLFROUND;
      return AddOn;
    },
    data_clientes() {
      let clientes = [];
      let rowclientes = Cliente.getClientsList();
      rowclientes.forEach((element) => {
        if (element.Id != "PUBLICOGENERAL") {
          clientes.push(element);
        }
      });

      return clientes;
    },
    typePaid() {
      return this.$store.getters.getTypePaid;
    },
    comp_clients() {
      let clientes = [];
      this.data_clientes.forEach((cli) => {
        if (cli.ExtraData?.Membresia?.Membresia) {
          cli.esMiembro = true;
        } else {
          cli.esMiembro = false;
        }
        cli.text = cli.getNombreCompleto();
        clientes.push(cli);
      });
      return this.$_.orderBy(clientes, "text", "asc");
      //return clientes;
    },
    grandTotal() {
      /* calcula el total de la reserva, segun el tipo de pago y los items seleccionados */

      let total = 0;
      let totalPesos = 0;

      this.players.forEach((element) => {
        if (element.TarifaSelected) {
          let montoTarifa = element.Precio;
          if (element.TarifaSelected.Moneda == "USD") {
            total += montoTarifa;
            totalPesos += montoTarifa * this.tiposCambio.TC.USD;
          } else {
            total += montoTarifa / this.tiposCambio.TC.USD;
            totalPesos += montoTarifa;
          }
        }
      });

      total += parseInt(this.TotalTrans);
      totalPesos += parseFloat(this.TotalTrans) * this.tiposCambio.TC.USD;

      this.players.forEach((element) => {
        if (element.golfClub) {
          if (this.Addons.golfClub.Moneda == "USD") {
            total += this.Addons.golfClub.Precio;
            totalPesos += this.Addons.golfClub.Precio * this.tiposCambio.TC.USD;
          } else {
            total += this.Addons.golfClub.Precio / this.tiposCambio.TC.USD;
            totalPesos += this.Addons.golfClub.Precio;
          }
        }
      });
      this.cartRiders.forEach((element) => {
        if (element.Pco.M == "USD") {
          total += Number(element.Pco.C);
          totalPesos += Number(element.Pco.C) * this.tiposCambio.TC.USD;
        } else {
          total += Number(element.Pco.C) / this.tiposCambio.TC.USD;
          totalPesos += Number(element.Pco.C);
        }
      });

      return { total: total, totalPesos: totalPesos };
    },
  },
  watch: {},
  beforeMount() {
    if (this.selectedT.length == 1) {
      this.input_date = new moment(this.selectedT[0].date);
      this.selectedTime = this.selectedT[0].time;
      this.input_date_end = new moment(this.selectedT[0].date);
      this.selectedTime_end = this.selectedT[0].endTime;
    } else {
      this.input_date = new moment(this.selectedT[0].date);
      this.selectedTime = this.selectedT[0].time;
      this.input_date_end = new moment(this.selectedT[1].date);
      this.selectedTime_end = this.selectedT[1].time;
    }

    //this.getUserGroups();
    this.getConfig();
    this.init();
  },
  mounted() {
    if (this.editMode) {
      //this.Id =
      this.doAction = "EDIT";
    } else {
      this.doAction = "CRATE";
    }
  },
  created() {
    this.allowPlayers =
      Number(this.maxPlayers) -
      Number(this.selectedT.personas ? this.selectedT.personas : 0);
  },
};
</script>
<style>
.btnCard {
  border: 2px solid !important;
  border-color: #1976d2 !important;
}
.accesoDenegado {
  background: #ff00005c;
}
.bottomPanel {
  width: 100%;
}
@media screen and (max-width: 600px) {
  .bottomPanel {
    width: 100%;
  }
}
</style>
